import { useQuery } from '@tanstack/react-query'

import { getIdentityVerificationsLatest } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchIdentityVerificationsLatest = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getIdentityVerificationsLatest(axiosInstance, organizationId),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_IDENTITY_VERIFICATIONS_LATEST],
  })
}
